import React, { useState } from "react";
import Salary from "..";
import DatePicker from "react-datepicker";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import useRead from "../../../hooks/useRead";
import SelectSearch from "react-select-search";
import useReadWithGet from "../../../hooks/read/useReadWithGetMethod";
import useDownloadFile from "../../../hooks/useDownloadFile";
import Pagination from "../../../components/pagination";
import CompanyPayroll from "../CompanyPayroll";
import spinner from "../../../assets/images/spinner.gif";
import PrimaryLoader from "../../../components/common/PrimaryLoader";
import BreadCrumbs from "../../../components/ui/BreadCrumbs";
import { Button } from "../../../components/ui";
import RoundedContainer from "../../../components/containers/RoundedContainer";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../../components/table/Table";

const getDateMonthString = (date) => {
  let tempDate = new Date(date);
  let month = tempDate.getMonth() + 1;
  return tempDate.getFullYear() + "-" + month;
};

const ProvidentFund = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const breadcrumbs = [
    { label: "Salary", link: "/salary" },
    { label: "Provident Fund", link: "" },
  ];

  const navigate = useNavigate();

  let initialData = {
    month_and_year: searchParams.get("month_and_year")
      ? new Date(searchParams.get("month_and_year"))
      : new Date(),
    prev_month_and_year: new Date(),
    page_number: searchParams.get("page_number") || 0,
    limit: searchParams.get("limit") || 50,
    search_query: searchParams.get("search_query") || "",
    screen_name: "PF",
  };

  const { list, paramsObject, setGetListParams } = useRead({
    url: "getMemberPayouts",
    initialData,
  });

  const { reportDownload } = useDownloadFile({
    url: "salary_report",
    filename: "provident-fund-report.xlsx",
  });

  const handleSearch = (e) => {
    let value = e.target.value;
    let data = {
      ...paramsObject,
      search_query: value,
      page_number: 0,
    };
    setGetListParams(data);
    setSearchParams(data);
  };

  const handleDate = (value) => {
    let data = {
      ...paramsObject,
      month_and_year: value,
    };
    setGetListParams(data);
    setSearchParams(data);
  };

  const handleDownloadReport = () => {
    let data = {
      month_year: getDateMonthString(paramsObject["month_and_year"]),
      type: "epf",
    };
    reportDownload.mutate(data);
  };

  const handleNavigateToEmployeeDetail = (id, username) => {
    navigate(
      `/employee-salary-details/${id}/${username}?source=provident-fund`
    );
  };

  const handlePageClick = (val) => {
    let data = {
      ...paramsObject,
      page_number: val.selected,
    };
    setGetListParams(data);
    setSearchParams(data);
  };

  return (
    <Salary>
      <div className="px-4 my-5">
        <BreadCrumbs crumbs={breadcrumbs} />
      </div>
      <div className=" mt-14 mb-20">
        <div className="">
          <form className="flex items-end justify-between px-5">
            <div className="flex items-end space-x-4">
              <div>
                <input
                  type="text"
                  placeholder="Search By Name..."
                  name="search_query"
                  className="input"
                  onChange={handleSearch}
                />
              </div>
              <div className="min-w-[10rem]  basis-[35%]">
                <label className=" roboto label">Select Month/Year</label>
                <DatePicker
                  required
                  name="month_and_year"
                  autoComplete="false"
                  className="input"
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                  selected={paramsObject?.month_and_year}
                  onChange={(value) => handleDate(value, "month_and_year")}
                />
              </div>
            </div>
            <div className="px-4">
              <div className="flex space-x-4 items-end justify-between">
                {/* {salaryList?.length > 0 &&
                <div className=''>
                    <Button type='button' onClick={handleDownloadReport}>Download Report</Button>
                </div>} */}
                <div className="">
                  <Button type="button" onClick={handleDownloadReport}>
                    Download Report
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <CompanyPayroll data={list.data?.total_data} type={"pf"} />

        {list.isLoading ? (
          <div className=" flex items-center justify-center mt-10">
            {" "}
            <PrimaryLoader />
          </div>
        ) : list.data?.data?.length <= 0 ? (
          <div className="text-center">
            <p className=" text-gray-700 text-3xl mt-4">
              No Employee/Consultant Found
            </p>
          </div>
        ) : (
          <>
            <RoundedContainer className="mx-5">
              <div className="max-w-full overflow-x-auto">
                <Table className="table-auto w-full">
                  <TableHead>
                    <TableHeaderCell className="w-[10%] text-center">
                      Sr.No
                    </TableHeaderCell>
                    <TableHeaderCell className="w-[30%]">
                      Name
                    </TableHeaderCell>
                    <TableHeaderCell className="w-[20%]">
                      User Type
                    </TableHeaderCell>
                    <TableHeaderCell className="w-[20%] text-center">
                      Employer EPF
                    </TableHeaderCell>
                    <TableHeaderCell className="w-[20%] text-center">
                      Employee EPF
                    </TableHeaderCell>
                  </TableHead>
                  <TableBody>
                    {list.data?.data?.map((data, idx) => {
                      const {
                        employee_name,
                        user_type,
                        company_employee_id,
                        employer_epf,
                        epf,
                      } = data;
                      return (
                        <TableRow
                          key={idx}
                          className="cursor-pointer"
                          onClick={() =>
                            handleNavigateToEmployeeDetail(
                              company_employee_id,
                              employee_name
                            )
                          }
                        >
                          <TableCell className="text-center text-dark font-medium text-sm">
                            {paramsObject.limit *
                              (parseInt(paramsObject.page_number) + 1) -
                              (paramsObject.limit - (idx + 1))}
                          </TableCell>
                          <TableCell className="text-dark font-medium text-sm">
                            {employee_name}
                          </TableCell>
                          <TableCell className="text-dark font-medium text-sm capitalize">
                            {user_type}
                          </TableCell>
                          <TableCell className="text-center text-dark font-medium text-sm capitalize">
                            {employer_epf}
                          </TableCell>
                          <TableCell className="text-center text-dark font-medium text-sm capitalize">
                            {epf}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </div>
            </RoundedContainer>
            <RoundedContainer className="mx-5 mt-4">
              <Pagination
                currentPage={+paramsObject.page_number}
                lengthofItems={list.data?.total_count}
                limit={paramsObject.limit}
                onPageChange={handlePageClick}
              />
            </RoundedContainer>
          </>
        )}
      </div>
    </Salary>
  );
};

export default ProvidentFund;
